import React from "react";
import PropTypes from "prop-types";
import DeleteIcon from "@material-ui/icons/Delete";
import A_SecuredAction from "../../../Atoms/Security/A_SecuredAction";
import { pageSecurityActions } from "../../../../../Utils/Helpers/pageSecurity";
import IconAction from "./IconAction";
import StatusTag from "./StatusTag";
import useStyles from "./ProfessionalContacts.styles";

const AddressList = ({ addresses, onSetPreferred, onDelete }) => {
  const classes = useStyles();
  return (
    <>
      {addresses.map((address) => (
        <div key={address.id} className={classes.rowItem}>
          <span className={classes.rowGrow}>
            {[
              address.building,
              address.street,
              address.town,
              address.postcode,
              address.country,
            ]
              .filter(Boolean)
              .join(", ")}
          </span>
          {address.isPreferred ? (
            <StatusTag tone="valid">Preferred</StatusTag>
          ) : (
            <A_SecuredAction permission={pageSecurityActions.UPDATE}>
              <button
                type="button"
                className={classes.linkAction}
                onClick={() => onSetPreferred(address.id)}
              >
                Set Preferred
              </button>
            </A_SecuredAction>
          )}
          <A_SecuredAction permission={pageSecurityActions.DELETE}>
            <IconAction
              danger
              title="Delete Address"
              icon={<DeleteIcon fontSize="small" />}
              onClick={() => onDelete(address)}
            />
          </A_SecuredAction>
        </div>
      ))}
    </>
  );
};

AddressList.propTypes = {
  addresses: PropTypes.array.isRequired,
  onSetPreferred: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default AddressList;
